var _componentUiSpinner = function($context) {
    if (!$().spinner) {
        console.warn('Warning - jQuery UI components are not loaded.');
        return;
    }

    $context = $context instanceof jQuery ? $context : $(document);

    $context.find('.js-spinner-basic').spinner();

    $context.find('.js-spinner-positive').spinner({
        min: 0,
        decimals:0
    });

    // Spinner with currency
    $context.find('.js-spinner-currency').spinner({
        culture: 'pl-PL',
        numberFormat: 'C',
        min: 0
    });  
};

function init($context) {
    _componentUiSpinner($context);
}

export const JqueryUiForms = {
    init
}